import StepAlertCovenantsAddress from '../components/alert-covenants-address'
import StepAlertNextSetp from '../components/alert-next-step'

export default {
  StepAlertCovenantsAddress,
  StepAlertNextSetp
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/components.js